document.addEventListener("DOMContentLoaded", function () {
  const options = {
    threshold: 0.3,
  };
  const isShopifyDesignMode = window.Shopify?.designMode === true;
  const animationItemSelector = "yg-animation-item, .yg-animation-item";

  function consumeSavedScrollPosition() {
    try {
      window.sessionStorage.removeItem(getScrollRestoreKey());
    } catch (error) {
      // ignore
    }
  }

  function initAnimation(el) {
    // 防止重复初始化
    if (el.dataset.animatedInit) return;

    el.dataset.animatedInit = "true";
    el.classList.add("fade-in-on-scroll");

    if (isShopifyDesignMode) {
      el.classList.add("yg-animated");
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("yg-animated");
          observer.unobserve(entry.target);
        }
      });
    }, options);

    observer.observe(el);

    // 保存 observer，方便销毁
    el._animationObserver = observer;
  }

  class DynamicItem extends HTMLElement {
    connectedCallback() {
      initAnimation(this);
    }

    disconnectedCallback() {
      this._animationObserver?.disconnect();
    }
  }

  // 支持 <yg-animation-item>
  if (!customElements.get("yg-animation-item")) {
    customElements.define("yg-animation-item", DynamicItem);
  }

  function initAnimationItems(root = document) {
    if (!root.querySelectorAll) return;

    if (root.matches?.(animationItemSelector)) {
      initAnimation(root);
    }

    root.querySelectorAll(animationItemSelector).forEach(initAnimation);
  }

  // 支持 class="yg-animation-item"
  initAnimationItems();

  if (isShopifyDesignMode) {
    document.addEventListener("shopify:section:load", (event) => {
      initAnimationItems(event.target);
    });

    const animationMutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            initAnimationItems(node);
          }
        });

        if (
          mutation.type === "attributes" &&
          mutation.target.nodeType === Node.ELEMENT_NODE &&
          mutation.target.matches?.(animationItemSelector)
        ) {
          initAnimation(mutation.target);
        }
      });
    });

    animationMutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  }

});
!function(){let e=e=>!function e(t){if(t.length%4!=0||!/^[A-Za-z0-9+/=]+$/.test(t))return!1;try{return atob(t),!0}catch(r){return!1}}(e)?e:decodeURIComponent(escape(window.atob(e))),t={is_mark:"F",shop_domain:window?.Shopify?.shop||"",watermark_text:e("5rC05Y2w5paH5pys"),watermark_size:"20px",watermark_color:"#333333"},r=`${e("aHR0cHM6Ly9haXMueWlndW90ZWNoLmNvbS9zaXRlbWFyay9wcm90ZWN0aW9uL2FwaS92MS93YXRlcm1hcms=")}?shop_domain=${t.shop_domain}`,i=()=>{fetch(r).then(e=>{e.json().then(e=>{"success"===e.result&&(t={...t,...e,expire_time:Date.now()+864e5},"T"===e.is_mark&&n(t),localStorage.setItem("sitemark_watermark",JSON.stringify(t)))})})},s=null,n=e=>{if(s){s.disconnect();return}let{watermark_text:t,watermark_size:r,watermark_color:i}=e,o=document.createElement("div");o.style.position="absolute",o.style.zIndex="9999",o.style.left="50%",o.style.bottom="0",o.style.fontSize=r,o.style.color=i,o.innerHTML=t,setTimeout(()=>{let t=document.querySelector("footer");t?(t.style.position="relative",t.appendChild(o),(s=new MutationObserver(t=>{s.disconnect(),s=null,n(e)})).observe(t,{attributes:!0,childList:!0,subtree:!0})):(o.style.position="fixed",document.body.appendChild(o))},1e3)},o=localStorage.getItem("sitemark_watermark");if(o){let a=JSON.parse(o);t={...t,...a},a.expire_time&&a.expire_time<Date.now()?i():"T"===a.is_mark&&n(t)}else i()}();
